import { Container, Text } from '../../../odie';
import { config } from '../../../game/defs/config';
import { GoalId, getGoalMap } from '../../../game/defs/goal';
import { BasicHandler } from '../../../lib/defs/types';
import { GoalPicker } from './GoalPicker';
import { NumberPicker } from '../../../lib/ui/NumberPicker';

/*
    puzzle editor goals menu goal picker
*/
export class EditorGoalPicker extends Container {
  // private
  //-------------------------------------------------------------------------
  // events
  public onUpdated?: BasicHandler;
  public onManuallyChanged?: BasicHandler;
  // scene
  private _goalPicker!: GoalPicker;
  private _countPicker!: NumberPicker;
  private _usedCountView!: Text;
  private _usedCount = 0;
  private _isSpawnable = false;

  // properties
  //-------------------------------------------------------------------------
  public get goalId(): GoalId {
    return this._goalPicker.goalId;
  }

  public set goalId(id: GoalId) {
    this._goalPicker.goalId = id;
  }

  public get count(): number {
    return this._countPicker.value;
  }

  public set count(value: number) {
    this._countPicker.value = value;
  }

  public get usedCount(): number {
    return this._usedCount;
  }

  public set usedCount(value: number) {
    this._usedCount = value;
    this._usedCountView.text = `${value.toString()}${
      this._isSpawnable ? '(*)' : ''
    }`;
    this._refreshCountPickerMax();
  }

  public get spawnable() {
    return this._isSpawnable;
  }

  public set spawnable(value: boolean) {
    this._isSpawnable = value;
    this._refreshCountPickerMax();
  }

  public isEmpty() {
    return this.count === 0 && this.goalId.startsWith('basic');
  }

  // init
  //-------------------------------------------------------------------------
  constructor(opts: { height: number }) {
    super();
    this.height = opts.height;

    // spawn block picker
    this._spawnBlockPicker();

    // spawn count picker
    this._spawnCountPicker();

    // spawn used count
    this._spawnUsedCount();
  }

  public static assets(): string[] {
    return [
      ...NumberPicker.assets(),
      ...GoalPicker.assets(),
      ...Object.values(getGoalMap()),
    ];
  }

  // private: spawners
  //-------------------------------------------------------------------------
  private _spawnBlockPicker() {
    const goalIds = Object.keys(getGoalMap()).filter(
      (key) => !!(getGoalMap() as Record<string, string>)[key],
    ) as GoalId[];
    const picker = (this._goalPicker = this.addChild(
      new GoalPicker({
        goalIds,
        height: this.height,
      }),
    ));
    picker.onUpdated = () => {
      this.onManuallyChanged?.();
      this.onUpdated?.();
    };
    picker.x = 0;
  }

  private _spawnCountPicker() {
    this._countPicker = this.addChild(
      new NumberPicker({
        value: 0,
        min: 0,
        max: config.goals.limit,
        width: 220,
        height: this.height,
      }),
    );
    this._countPicker.x = this._goalPicker.width + 5;
    this._countPicker.onChanged = () => {
      this.onManuallyChanged?.();
    };
  }

  private _spawnUsedCount() {
    this._usedCountView = new Text('0');
    this._usedCountView.setTextOpts({ size: 30 });
    this._usedCountView.width = 60;
    this._usedCountView.height = this.height;
    this._usedCountView.x = this._countPicker.x + this._countPicker.width + 5;
    this._usedCountView.y = 3;
    this.addChild(this._usedCountView);
  }

  // private: utils
  //-------------------------------------------------------------------------
  private _refreshCountPickerMax() {
    this._countPicker.max = this._isSpawnable
      ? config.goals.limit
      : this.usedCount;
  }
}
